<template>
        <b-form-input v-model="quantity" class="my_custom_input_product_quantity"
                      :disabled="!!getBasketItemById"
                      type="number" min="0" aria-label="Text input with checkbox"
                      @input="changeProductQuantity"
        />
</template>

<script>
    import {mapGetters} from 'vuex';
    import _u from "jsAssets/utils/index";
    import FavoriteProduct from "vueComponents/product/favorite/FavoriteCatalogItem";

    /**
     * Компонент представляет собой input который сохраняет в хранилище количество товара с Id - product_id.
     *
     * Для работы необходимо передать Id товара к которому относится компонент
     *
     * @vuedoc
     * @module vue:components/ProductDetailInput
     * @exports vue:components/ProductDetailInput
     */

    export default {
        name: "product-detail-input",


        props: [
            'product_id'
        ],
        /**
         * Данные экземпляра компонента
         *
         * @method data
         * @property {string} quantity - Значение input - количество товаров , по дефолту имеет значение "1"
         * @property {string|int} productId - Id товара
         *
         */
        data() {
            return {
                quantity: "1",
                productId: this.product_id
            }
        },

        computed: {
            ...mapGetters('productQuantity', [
                'productQuantity',
            ]),

            ...mapGetters('basket', [
                'basketItems',
            ]),
            /**
             *  Вычисляемое свойство которое в зависемости от Id товара определяет его принадлежность
             *  к корзине, если товар есть в корзине то input получает статус disabled, а так же значение input становиться
             *  равным количеству элементов в корзине
             *
             * @method getBasketItemById
             */
            getBasketItemById() {
                if(this.basketItems && this.basketItems[this.productId] !== 'undefined') {
                    this.item = this.basketItems[this.productId];
                    this.quantity = this.productQuantity[this.productId] ? this.productQuantity[this.productId]:this.quantity;
                    this.quantity = (this.item && this.item.quantity ? this.item.quantity :this.quantity ).toString();
                    return this.basketItems[this.productId];
                }
                return false;
            },

        },

        mounted(){
        },


        methods: {
            /**
             *  Метод сохраняет в хранилище количество обраных товаров с Id - this.productId
             *
             * @method changeProductQuantity
             */
            changeProductQuantity(value){
                if (value <= 0) {
                    this.$nextTick(() => {
                        this.quantity = 1;
                    });
                } else {
                    this.$store.commit('productQuantity/setProductQuantity', {id: this.productId, quantity: value});
                }
            },
        }
    }


</script>
